// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import axios from "axios";
import { store } from "@/store";
import * as types from "@/utils/Types";

/**
 * Gets an authorization and refresh tokens for a user
 * @param loginToken Token retrieved by log in
 * @returns An authentication and refresh token pair
 */
async function getAuthTokens(
  loginToken: string
): Promise<types.authTokens | null> {
  console.log('getauthtokens', loginToken);

  try {
    const res = await axios.get<types.authTokens>(`/auth/authorize`, {
      headers: { Authorization: `Bearer ${loginToken}` },
    });
    console.log('res tokens: ', res);

    store.commit("setAuthTokens", res.data);
    console.log("AUTH DATA",res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets new authorization and refresh tokens for a user
 * @returns The HTTP response code
 */
async function refreshTokens(): Promise<number | null> {
  //Collects the old refresh token and reset the tokens
  const token = store.state.authTokens?.refreshToken;
  store.state.authTokens = undefined;
  //Make API request
  try {
    const res = await axios.get<types.authTokens>(`/auth/refresh`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    store.commit("setAuthTokens", res.data);
    return res.status;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export { getAuthTokens, refreshTokens };
